// removed by extract-text-webpack-plugin
module.exports = {"Layout":"_2C2_cL2y9o3hHDuzV_hszk"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 653
// module chunks = 0